var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlombergInformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3932 24.8495L12.4438 25.5562L13.1505 20.6068L25.8786 7.87869C26.4412 7.31607 27.2043 7 28 7C28.7956 7 29.5587 7.31607 30.1213 7.87869C30.6839 8.44131 31 9.20438 31 10C31 10.7957 30.6839 11.5588 30.1213 12.1214L17.3932 24.8495Z",
    stroke: "#CB403C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 1H8.00001C7.44772 1 7 1.44772 7 2.00001V4.00002C7 4.55231 7.44772 5.00003 8.00001 5.00003H16.0001C16.5524 5.00003 17.0001 4.55231 17.0001 4.00002V2.00001C17.0001 1.44772 16.5524 1 16.0001 1Z",
    stroke: "#CB403C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 3H21C21.5305 3 22.0392 3.21072 22.4143 3.58579C22.7893 3.96087 23 4.46958 23 5.00002",
    stroke: "#CB403C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0002 25.0002V29.0002C23.0002 29.5306 22.7895 30.0393 22.4144 30.4144C22.0393 30.7895 21.5306 31.0002 21.0002 31.0002H3.00002C2.46958 31.0002 1.96087 30.7895 1.58579 30.4144C1.21072 30.0393 1 29.5306 1 29.0002V5.00002C1 4.46958 1.21072 3.96087 1.58579 3.58579C1.96087 3.21072 2.46958 3 3.00002 3H7.00005",
    stroke: "#CB403C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11H17.0001",
    stroke: "#CB403C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 17H11",
    stroke: "#CB403C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlombergInformation);
export default __webpack_public_path__ + "static/media/blomberg-information.b6d99921a4604090885d71d3037fccda.svg";
export { ForwardRef as ReactComponent };